<template>
  <div class="nfc-touch-view" v-if="inited">
    <LandingIntro 
      v-if="showLanding" 
      @close="showLanding = false" 
      @start-binding="startBinding"
      hideBuyButton>
    </LandingIntro>
    <div v-if="!showLanding">
      <div v-if="bagInfo === null" class="text-center py-3">
        <p>無法讀 Touch In 收納袋的資訊...</p>
      </div>
  
      <div v-else>
        <div class="top-sticky">
          <div>
            <router-link
              class="back-to-list-link"
              :to="{name: 'ClosetContentListAll'}"
              aria-label="返回衣櫥"
            >
              <Icon name="chevron-left" size="24" />
            </router-link>
          </div>
          <div>
          </div>
          <div class="link-title">{{ bagInfo.bag.name }}</div>
        </div>
  
        <div class="bottom-content">
          <div class="container">
            <ClothCardList
              :cloths="bagInfo.clothes"
              :showTitle="false"
              @clothClicked="clothClicked"
            ></ClothCardList>
          </div>
        </div>
  
        <transition name="fade">
          <FullScreenModal v-if="showViewCloth" title="檢視單品" @back="closeViewClothModal">
            <ViewClothContent :cloth="selectedCloth"></ViewClothContent>
          </FullScreenModal>
        </transition>
      </div>
    </div>
    
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import commonBusyAndErrorHandling from '@/assets/js/commonBusyAndErrorHandling.js';
import ClothCardList from '@/components/clothList/ClothCardList.vue';
import FullScreenModal from '@/components/FullScreenModal.vue';
import ViewClothContent from '@/views/closet/ViewClothContent';
import LandingIntro from '../../../components/closet/touchin/LandingIntro.vue';

export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'TouchInBagPublicView',
  data() {
    return {
      ReadingBusy: 'TouchInBagInfoReading',
      SavingBusy: 'TouchInBagInfoSaving',

      bagInfo: null,
      inited: false,
      showLanding: false,
      bagUID: '',
      
      showViewCloth: false,
      selectedCloth: {},
      // code: '',
    };
  },
  props: {
  },
  components: {
    ClothCardList,
    FullScreenModal,
    ViewClothContent,
    LandingIntro,
  },
  computed: {
    ...mapGetters(['isTester']),

  },
  async mounted() {
    const busyName = 'TOUCHIN_INIT_BUSY';
    this.appendComponentBusy(busyName);
    try {
      // do nothing
      this.bagUID = this.$route.params.id;
      const data = await this.$store.dispatch('api/getNFCTokenPublicInfoPromise', this.bagUID);
      if (!data.bag) {
        throw new Error('無法讀取 Touch In 收納袋的資訊');
      }
      // console.log(data);
      this.bagInfo = Object.assign({}, data);
    } catch (error) {
      // alert(`發生錯誤: ${error.toString()}`);
      this.showLanding = true;
      console.error(error);
    } finally {
      this.clearComponentBusy(busyName);
      this.inited = true;
    }
    
  },
  methods: {
    ... mapActions(['appendComponentBusy', 'clearComponentBusy']),
    closeViewClothModal() {
      this.showViewCloth = false;
    },
    clothClicked(cloth) {
      this.selectedCloth = Object.assign({}, cloth);
      this.showViewCloth = true;
    },
    startBinding() {
      const { href } = this.$router.resolve({ name: 'TouchIn' });
      window.open(href, '_blank');
    },
  }
}
</script>


<style lang="scss" scoped>
@import "src/assets/scss/basic";

.nfc-touch-view {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 4rem;
  @include bigger-than-large {
    margin: 0 auto;
  }
  .top-sticky {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: .8rem .5rem;
    background-color: $color-main-yellow;
    // border-bottom: solid 1px $color-border;
    z-index: 10;
    .link-title {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 1.2em;
    }
    .back-to-list-link {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2rem;
      height: 2rem;
    }
  }

  .bottom-content {
    padding: 1rem 0;
  }
}
</style>